export default {
  data() {
    return {}
  },
  methods: {
    transKeyToLabel(key) {
      switch (key) {
        case 'addressName':
          return 'Address Name'
        case 'addressNumber':
          return 'Address Number'
        case 'addressTypeStr':
          return 'Address Type'
        case 'city':
          return 'CITY'
        case 'cnpj':
          return 'CNPJ'
        case 'companyName':
          return 'Company Name'

        case 'controlTypeStr':
          return 'Control Type'
        case 'duns':
          return 'DUNS'
        case 'email':
          return 'Email'
        case 'fullAddress':
          return 'Full Address'
        case 'homePage':
          return 'HomePage'
        case 'lineOfBusines':
          return 'Line Of Busines'
        case 'neighborhood':
          return 'Neighborhood'
        case 'numberOfEmployees':
          return 'Number Of Employees'
        case 'phone':
          return 'Phone'
        case 'postalCode':
          return 'Postal Code'
        case 'registryDate':
          return 'Registry Date'
        case 'sic':
          return 'Sic'
        case 'statusStr':
          return 'Status'
        case 'taxId':
          return 'TaxID'
        case 'commercialName':
          return 'Trading Style'
        case 'typeSocietyStr':
          return 'Type Society'
        // corporate -----
        case 'currency':
          return 'Currency'
        case 'fullyPaidInStr':
          return 'Fully Paid In'
        case 'lastChangeInTheShareCapital':
          return 'Last Change In The Share Capital'
        case 'socialCapitalValue':
          return 'Social Capital Value'
        // restrict summary --------
        case 'billSumCurrency':
          return 'Bill Sum Currency'
        case 'numOfReturnedChecks':
          return 'Num Of Returned Checks'
        case 'numberOfProtestedBills':
          return 'Number Of Protested Bills'
        case 'numberOfSas':
          return 'Number Of SAS'
        case 'pefinTotaLAmount':
          return 'Pefin Total Amount'
        case 'pefinTotalCurrency':
          return 'Pefin Total Currency'
        case 'pefinTotalOccurrences':
          return 'Pefin Total Occurrences'
        case 'pefinTotalOccurrencesPhraseStr':
          return 'Pefin Total Occurrences Phrase'
        case 'pefinTotalSearchDate':
          return 'Pefin Total Search Date'
        case 'pefinTotalSupplierStr':
          return 'Pefin Total Supplier'
        case 'totalLawsuitsNumber':
          return 'Total Lawsuits Number'
        case 'numberOfExecutionSuits':
          return 'Number Of Execution Suits'
        case 'totalLegalEvents':
          return 'Total Legal Events'
        case 'totalPetitions':
          return 'Total Petitions'
        case 'totalProtests':
          return 'Total Protests'
        // foundationHistoryVO
        case 'foundationHeadingStr':
          return 'Foundation Heading'
        case 'foundationDate':
          return 'Foundation Date'
        case 'date':
          return 'Date'
        case 'firstSocialName':
          return 'First Social Name'
      }
    },
  },
}
